module.exports = __webpack_public_path__ + "images/kabobMenu-4fbe0792ef398c02be5705f07b5f87cb.svg";